import React from "react";
import HoverFlag from "MODULES/parts/components/HoverFlag";
import { LOOKING_FOR } from "MODULES/OutgoingQuotes/constants";
import { get } from "lodash";
import NoteTooltip from "../../shared/components/NoteTooltip/NoteTooltip";

export function LookingForFlags({ lineItem }) {
  if (lineItem.locked) {
    return (
      <NoteTooltip
        color="white"
        note={`Locked By ${get(lineItem, "locked_audit.updated_by.full_name")}`}
        icon="fa-lock"
      />
    );
  }

  if (lineItem.looking_for) {
    return <HoverFlag text={LOOKING_FOR} abbr="LF" inline />;
  }

  return null;
}



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/shared/LookingForFlags.jsx